import { Nav, Tab } from "react-bootstrap";
import { IComplianceInvestigationActionOrInstructionDetails } from "../../../../api/ComplianceInvestigation/IComplianceInvestigationActionsAndInstructions";
import { ILicenceProfile } from "../../../../api/LicenceProfile";
import { EdenMessagesGrid } from "../../../../leap-components/EdenMessages/EdenMessagesGrid";
import { EdenMessagesGridType } from "../../../../leap-components/EdenMessages/EdenMessagesGridProps";
import EpaCard from "../../../../leap-components/EpaCard";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  licenceProfile: ILicenceProfile;
  actionOrInstruction: IComplianceInvestigationActionOrInstructionDetails;
}

interface ActionOrInstructionProps {
  licenceProfile: ILicenceProfile;
  actionOrInstruction: IComplianceInvestigationActionOrInstructionDetails;
}

const SubTabs = ({
  className,
  activeKey,
  licenceProfile,
  actionOrInstruction,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="messages">Messages</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="messages">
          <EdenMessagesGrid
            edenMessagesType={EdenMessagesGridType.TaskBasedEdenMessages}
            profileNumber={licenceProfile.profileNo}
            taskId={actionOrInstruction.taskid}
          />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({
  licenceProfile,
  actionOrInstruction,
}: ActionOrInstructionProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="messages"
      licenceProfile={licenceProfile}
      actionOrInstruction={actionOrInstruction}
    />
  );

  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
